





document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.landing-banner').forEach((banner) => {
    const slides = banner.querySelectorAll('.landing-banner__slide');
    if (slides.length <= 1) return;

    const delay = parseInt(banner.dataset.autoplay, 10) || 5000;
    let index = 0;

    setInterval(() => {
      slides[index].classList.remove('is-active');
      index = (index + 1) % slides.length;
      slides[index].classList.add('is-active');
    }, delay);
  });
});
